import { Timestamp } from 'src/types'

export type ChartDataItem = {
  date: string
  maintenance: number
  fuel: number
}

export type MapHistory = {
  date: Timestamp
  countOfCost: number
  currency: string
}

export enum PeriodChartInMonth {
  MONTH = '1',
  THREE_MONTH = '3',
  HALF_YEAR = '6',
  YEAR = '12',
}
